import {AxiosError, isAxiosError} from 'axios';
import {VanillaException} from '@/exceptions/VanillaException';

/**
 * ForbiddenExceptions that mean a missing permission. Other 403 exceptions (view as role read-only, partner logins,
 * "Bereits abgerechnet", …) keep their own message: a permission request would not help there.
 */
export const PERMISSION_EXCEPTION_TYPES = [
    'ForbiddenCrudActionException',
    'ForbiddenTypeAccessException',
    'ForbiddenEntityAccessException',
    'MissingCustomAccessKeyException',
    'ForbiddenSortException',
];

/** A 403 that opened the "Zugriff verweigert" dialog (store `unauthorized`); unauthorizedInfo.ts prepares it lazily */
export interface UnauthorizedEvent {
    /** Raw axios error or permission VanillaException */
    error: unknown;
    clientRoute: string;
    occurredAt: Date;
}

/** Failed request of a VanillaException (api.class.ts casts the axios error away, the dialog still shows the request) */
const failedRequests = new WeakMap<VanillaException, AxiosError>();

export function rememberFailedRequest(exception: VanillaException, error: unknown) {
    if (isAxiosError(error)) {
        failedRequests.set(exception, error);
    }
}

export function failedRequestOf(exception: VanillaException): AxiosError | undefined {
    return failedRequests.get(exception);
}

/** VanillaException of a missing permission (see PERMISSION_EXCEPTION_TYPES) */
export function isPermissionException(error: unknown): error is VanillaException {
    return error instanceof VanillaException && error.namespace === 'ForbiddenExceptions'
        && PERMISSION_EXCEPTION_TYPES.includes(error.type);
}
